import React from "react";
import {
  CARD_BORDER,
  DEBT_CARD_TITLE_FONT_SIZE,
  DEBT_DRAWER_CANCEL_BG,
  DEBT_DRAWER_MAX_WIDTH,
  DEBT_DRAWER_PRIMARY_ACTION,
} from "./DebtCollectionSectionConstants";

/**
 * Injects scoped CSS for debt collection section layout, drawer, and close modal.
 * @returns {JSX.Element} Hidden `<style>` element.
 */
export function DebtCollectionSectionScopedCss() {
  return (
    <style>
      {`
#debt-collection-section .debt-summary-tile-label {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}
#debt-collection-section .card-body {
  border-radius: 0.42rem !important;
}
#debt-collection-section .debt-summary-tile-value {
  font-size: ${DEBT_CARD_TITLE_FONT_SIZE} !important;
  font-weight: 700 !important;
}
#debt-collection-section .debt-info-panel-title,
#kt_franchise_debt_panel .debt-info-panel-title {
  font-size: ${DEBT_CARD_TITLE_FONT_SIZE} !important;
  font-weight: 700 !important;
}
#debt-collection-section .debt-info-panel-body,
#debt-collection-section .debt-info-panel-body .small,
#kt_franchise_debt_panel .debt-info-panel-body,
#kt_franchise_debt_panel .debt-info-panel-body .small {
  font-size: 0.875rem !important;
}
#debt-collection-section .debt-summary-with-status-row {
  align-items: stretch;
}
#debt-collection-section .debt-summary-with-status-row .debt-summary-tiles-spacer {
  flex: 1 1 auto;
  min-height: 0;
}
#debt-collection-section .debt-status-rules-panel-flex {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
}
#kt_franchise_debt_panel.offcanvas.offcanvas-right {
  max-width: ${DEBT_DRAWER_MAX_WIDTH} !important;
  width: 100% !important;
  /* Fill viewport; footer visible, body scrolls inside */
  display: flex !important;
  flex-direction: column !important;
  max-height: 100vh !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  padding-bottom: 1.75rem !important;
}
#kt_franchise_debt_panel .debt-drawer-form {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
#kt_franchise_debt_panel .debt-drawer-scroll-body {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
}
#kt_franchise_debt_panel .debt-drawer-step-panel {
  border: 1px solid ${CARD_BORDER};
  border-radius: 0.5rem;
  padding: 1.25rem;
}
#kt_franchise_debt_panel .debt-drawer-date-field .react-datepicker-wrapper {
  display: block !important;
  width: 100%;
}
#kt_franchise_debt_panel .debt-drawer-date-field .react-datepicker__input-container {
  display: block !important;
  width: 100%;
}
#kt_franchise_debt_panel .debt-drawer-date-input {
  width: 100% !important;
  padding-right: 2.75rem !important;
}
/* Bootstrap is-invalid SVG overlaps calendar button; error text is shown below */
#kt_franchise_debt_panel .debt-drawer-date-input.is-invalid {
  background-image: none !important;
  padding-right: 2.75rem !important;
}
#kt_franchise_debt_panel .debt-drawer-date-calendar-btn {
  position: absolute;
  z-index: 2;
  top: 1px;
  right: 1px;
  bottom: 1px;
  width: 2.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0;
  cursor: pointer;
}
#kt_franchise_debt_panel .debt-drawer-date-calendar-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
#kt_franchise_debt_panel .debt-drawer-date-calendar-btn:focus {
  outline: none;
  box-shadow: none;
}
#kt_franchise_debt_panel .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
#kt_franchise_debt_panel .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle {
  left: 50% !important;
  margin-left: 0 !important;
  transform: translateX(-50%) !important;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-cancel,
#kt_franchise_debt_panel .debt-drawer-footer-btn-primary {
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.5;
  border-radius: 8px;
  min-height: 42px;
  padding: 0 1.25rem;
  min-width: 96px;
  border: none;
  color: #fff !important;
  box-shadow: none;
  transition: background-color 0.15s ease;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-cancel {
  background-color: ${DEBT_DRAWER_CANCEL_BG} !important;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-cancel:hover:not(:disabled) {
  background-color: #111827 !important;
  color: #fff !important;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-cancel:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-primary {
  background-color: ${DEBT_DRAWER_PRIMARY_ACTION} !important;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-primary:hover:not(:disabled) {
  background-color: #e65f00 !important;
  color: #fff !important;
}
#kt_franchise_debt_panel .debt-drawer-footer-btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.debt-close-account-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  min-height: 100vh !important;
}
.modal.debt-close-account-modal-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  min-height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 1.75rem 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.modal-dialog.debt-close-account-dialog.modal-dialog-centered {
  min-height: 0 !important;
  margin: 0 auto !important;
  max-height: calc(100vh - 3.5rem);
  overflow-y: auto;
}
.debt-close-account-dialog .debt-close-modal-date-field .react-datepicker-wrapper {
  display: block !important;
  width: 100%;
}
.debt-close-account-dialog .debt-close-modal-date-field .react-datepicker__input-container {
  display: block !important;
  width: 100%;
}
.debt-close-account-dialog .debt-close-modal-date-input {
  width: 100% !important;
  padding-right: 2.75rem !important;
}
.debt-close-account-dialog .debt-close-modal-date-calendar-btn {
  position: absolute;
  z-index: 2;
  top: 1px;
  right: 1px;
  bottom: 1px;
  width: 2.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0;
  cursor: pointer;
}
.debt-close-account-dialog .debt-close-modal-date-calendar-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
.debt-close-account-dialog .debt-close-modal-date-calendar-btn:focus {
  outline: none;
  box-shadow: none;
}
.debt-close-account-dialog .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.debt-close-account-dialog .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle {
  left: 50% !important;
  margin-left: 0 !important;
  transform: translateX(-50%) !important;
}
.react-datepicker-popper.debt-close-datepicker-popper {
  z-index: 1060 !important;
}
      `}
    </style>
  );
}
